import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: 'page-footer, [page-footer], [pageFooter], mir-page-footer, [mir-page-footer], [mirPageFooter]',
    standalone: false
})
export class PageFooterDirective {

  @HostBinding('class') hostCssClasses = 'mir-page-footer page-footer';

}
